module.exports = __webpack_public_path__ + "static/img/060_TO8_1614.b7d2864.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/wedding/060_TO8_1614.jpg
// module id = xakz
// module chunks = 0